import {
  AppWindowIcon,
  ArrowLeftRightIcon,
  BookTextIcon,
  Building2Icon,
  BuildingIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleCheckIcon,
  CircleDashedIcon,
  CoinsIcon,
  CreditCardIcon,
  DollarSignIcon,
  FileSpreadsheetIcon,
  FingerprintPatternIcon,
  GitBranchIcon,
  IdCardIcon,
  LandmarkIcon,
  LayoutGridIcon,
  ListTreeIcon,
  PercentIcon,
  SearchIcon,
  TagsIcon,
  TextAlignStartIcon,
  UserLockIcon,
  createLucideIcon,
} from "lucide-react";

/**
 * The marks of the services the app connects to, which lucide does not draw:
 * Bootstrap's, filled - its 16px square grown to lucide's 24px.
 */
const filledMark = (name: string, d: string) =>
  createLucideIcon(name, [
    [
      "path",
      {
        d,
        fill: "currentColor",
        stroke: "none",
        transform: "scale(1.5)",
        key: name,
      },
    ],
  ]);
export const GoogleIcon = filledMark(
  "google",
  "M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z",
);
export const MicrosoftIcon = filledMark(
  "microsoft",
  "M7.462 0H0v7.19h7.462zM16 0H8.538v7.19H16zM7.462 8.211H0V16h7.462zm8.538 0H8.538V16H16z",
);
export const StripeIcon = filledMark(
  "stripe",
  "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.226 5.385c-.584 0-.937.164-.937.593 0 .468.607.674 1.36.93 1.228.415 2.844.963 2.851 2.993C11.5 11.868 9.924 13 7.63 13a7.7 7.7 0 0 1-3.009-.626V9.758c.926.506 2.095.88 3.01.88.617 0 1.058-.165 1.058-.671 0-.518-.658-.755-1.453-1.041C6.026 8.49 4.5 7.94 4.5 6.11 4.5 4.165 5.988 3 8.226 3a7.3 7.3 0 0 1 2.734.505v2.583c-.838-.45-1.896-.703-2.734-.703",
);

export const iconsByTypename = {
  EntityObject: BuildingIcon,
  FinancialAccountObject: CreditCardIcon,
  FinancialInstitutionObject: LandmarkIcon,
  StripeFinancialAccountObject: CreditCardIcon,
  TransactionObject: ArrowLeftRightIcon,
  ChartedAccountObject: ListTreeIcon,
  ContactObject: IdCardIcon,
  OrganizationObject: Building2Icon,
  DocumentTemplateObject: AppWindowIcon,
  JournalEntryObject: BookTextIcon,
  RuleDefinitionObject: BookTextIcon,
  RuleDelegationObject: UserLockIcon,
  DocumentObject: FileSpreadsheetIcon,
  ReportObject: LayoutGridIcon,
  TaxObject: CoinsIcon,
};

/* This represents icons (and their corresponding object keys) that are used in lots of objects.
 * This is to avoid having to import the same icon in many files, and to make it easier to change the icon
 * for all objects at once.
 */
export const icons = {
  amount: DollarSignIcon,
  chartedAccount: iconsByTypename.ChartedAccountObject,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  // What was waiting on review (``inReview``), confirmed: the same circle, drawn
  // whole.
  confirmed: CircleCheckIcon,
  description: TextAlignStartIcon,
  identifier: FingerprintPatternIcon,
  // A record waiting on someone's review - a draft in a chat, a change not yet
  // confirmed - wherever it is shown.
  inReview: CircleDashedIcon,
  name: IdCardIcon,
  percentage: PercentIcon,
  rate: PercentIcon,
  search: SearchIcon,
  tags: TagsIcon,
  journalEntry: iconsByTypename.JournalEntryObject,
};
